import { useQuery } from '@tanstack/react-query';
import { analysisService } from '../services/analysis.service';
import type { Analysis } from '../services/analysis.service';

export function useAnalysis(analysisId: string | null, includeGraph: boolean = true) {
  return useQuery<Analysis & { dependency_graph?: any }>({
    queryKey: ['analysis', analysisId, includeGraph],
    queryFn: () => {
      if (!analysisId) {
        return Promise.reject(new Error('Analysis ID is required'));
      }
      return analysisService.findById(analysisId, includeGraph);
    },
    enabled: !!analysisId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

